export default __webpack_public_path__ + "static/media/polygon_square_logo.55f0df10.svg";